// Order helpers — Instagram DM + WhatsApp
export const IG_HANDLE = "keilani_clothing";
export const IG_DM = "https://ig.me/m/keilani_clothing";
export const IG_PROFILE = "https://www.instagram.com/keilani_clothing/";

export const WA_NUMBER = "918137921196"; // +91 8137921196
export const WA_DISPLAY = "+91 81379 21196";

export function buildOrderMessage(product, size) {
  const price = `₹${product.price.toLocaleString("en-IN")}`;
  let fit = "my size";
  if (size && size !== "Custom") fit = `size ${size}`;
  else if (size === "Custom") fit = "a custom size";
  return `Hi Keilani! I'd love to order the ${product.name} (${price}) in ${fit}. Could you please share availability and the next steps?`;
}

export function buildGeneralMessage() {
  return "Hi Keilani! I came across your collection and would love to place an order. Could you help me with availability and sizes?";
}

export function waLink(message) {
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;
}

// Copy the prefilled message to clipboard, then open the Instagram DM.
export async function openOrderDM(message) {
  let copied = false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(message);
      copied = true;
    }
  } catch (e) {
    copied = false;
  }
  window.open(IG_DM, "_blank", "noopener,noreferrer");
  return copied;
}

// Open WhatsApp with prefilled message (works on both mobile & desktop web WA).
export function openOrderWA(message) {
  window.open(waLink(message), "_blank", "noopener,noreferrer");
}
